import React from 'react';
import Container from '@boschebike/ebds-react/dist-esm/components/Container.js';
import Button from '@boschebike/ebds-react/dist-esm/components/Button.js';
import { IconAsChunk } from '@boschebike/ebds-react';
/**
 * @typedef {import('../../App.d.ts').ComponentGetInTouchProps} ComponentGetInTouchProps
 */
/**
 *
 * @param {ComponentGetInTouchProps} props
 * @returns {Element}
 * @constructor
 */
export default ({ image, text, link }) => {
  return (
    <Container
      standout
      customContainerClassName="dodo-component-get-in-touch-container"
      customContentClassName="dodo-component-get-in-touch-container"
    >
      <div
        data-testid="get-in-touch"
        className="dodo-component-get-in-touch"
      >
        <div className="dodo-component-get-in-touch__left">
          <img
            src={image.src}
            srcSet={image.srcSet?.join(',')}
            alt={image.alt ?? ''}
          />
        </div>
        <div className="dodo-component-get-in-touch__right">
          <h2>{text.headline}</h2>
          <p>{text.description}</p>
          <Button
            name="dodo-component-get-in-touch"
            value="by-email"
            type="button"
            mode="tertiary"
            state="normal"
            href={link.href}
            icon={<IconAsChunk iconName="Mail" />}
            text={link.text}
            srText={link.srText}
            rawElementProps={{
              'data-test-id': 'component-get-in-touch-button',
              target: '_blank',
            }}
          />
        </div>
      </div>
    </Container>
  );
};
